import { DatePickerWithRange } from "@/common/components/ui/dateRangePicker";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterDateRangeHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  return (
    <DatePickerWithRange
      date={value}
      setDate={onChange}
      buttonClassName="min-h-[52px] text-sm not-italic bg-white-200 text-white-800 rounded-md shadow-none"
    />
  );
}

export default DashboardFilterDateRangeHiddenFilter;
